import React from 'react';
import { Tooltip, Slider } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setSelectedVendorTracePrevalenceFilters } from '../../../actions/diagnose_vendor_trace_actions';
import SVG from 'react-inlinesvg';
import prevalenceIcon from '../../../assets/icons/equalizer_prevalence.svg';

const VendorTracePrevalenceFilter = ({ selectedVendorTracePrevalenceFilter, setSelectedVendorTracePrevalenceFilters, selectedVendorName }) => {
    const onChange = (value) => {
        setSelectedVendorTracePrevalenceFilters([value, 100]);
    };

    const marks = {
        0: '0',
        25: '25',
        50: '50',
        75: '75',
        100: '100',
    };
    const formatter = (value) => `${value}%`;
    return (
        <div className={'vendor-trace-prevalence-filter-container'}>
            <div className={'vendor-trace-prevalence-filter-title-row'}>
                <SVG className={'prevalence-icon'} src={prevalenceIcon} />
                <div>Prevalence Range (%)</div>
                <Tooltip
                    placement="topRight"
                    overlayClassName="vendor-trace-prevalence-filter-tooltip-overlay"
                    title={() => {
                        return (
                            <div className={'vendor-trace-prevalence-filter-tooltip-content'}>
                                <div>The prevalence is the percentage of scans where we have seen
                                    this vendor across all scans set up on this url</div>
                            </div>
                        ); 
}
                    }
                >
                    <InfoCircleFilled />
                </Tooltip>
            </div>
            <div>
                <Slider
                    onChange={onChange}
                    min={0}
                    max={100}
                    marks={marks}
                    value={selectedVendorTracePrevalenceFilter[0]}
                    tipFormatter={formatter}
                    step={25}
                    className={'prevalence-range-slider'}
                    tooltipVisible
                    disabled={selectedVendorName}
                />
            </div>
        </div>
    );
};

const mapStateToProps = function (store) {
    return {
        selectedVendorTracePrevalenceFilter: store.diagnoseVendorTraceState.getIn(['vendorTracePrevalenceFilter', 'value']),
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setSelectedVendorTracePrevalenceFilters,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorTracePrevalenceFilter);
